module.exports = __webpack_public_path__ + "static/img/dinner2.7c3b677.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/pictures/dinner2.jpg
// module id = gPv4
// module chunks = 0